import { Link } from "react-router-dom";
import { Linkedin, Twitter, Github, Mail, MapPin, Phone } from "lucide-react";

export function Footer() {
  return (
    <footer className="border-t border-white/10 bg-ink">
      <div className="mx-auto max-w-7xl px-4 py-14 sm:px-6 lg:px-8">
        <div className="grid gap-10 md:grid-cols-4">
          <div>
            <Link to="/" className="flex items-center gap-3">
              <img
                src="/logo-stantive-mark.jpeg"
                alt=""
                className="h-16 w-16 shrink-0 rounded-xl bg-white object-contain p-1"
                width={64}
                height={64}
                aria-hidden="true"
              />
              <span className="font-display text-lg font-bold text-ink-foreground">
                Stantive Soft
              </span>
            </Link>
            <p className="mt-4 text-sm leading-relaxed text-ink-muted">
              Empowering businesses worldwide with quality engineering, custom development,
              Salesforce, cloud, and AI solutions built on simplicity, clarity, and reliability.
            </p>
            <div className="mt-5 flex gap-3">
              <a
                href="#"
                aria-label="LinkedIn"
                className="grid h-9 w-9 place-items-center rounded-lg border border-white/15 text-ink-muted transition-colors hover:border-primary-glow/40 hover:text-primary-glow"
              >
                <Linkedin size={16} />
              </a>
              <a
                href="#"
                aria-label="Twitter"
                className="grid h-9 w-9 place-items-center rounded-lg border border-white/15 text-ink-muted transition-colors hover:border-primary-glow/40 hover:text-primary-glow"
              >
                <Twitter size={16} />
              </a>
              <a
                href="#"
                aria-label="GitHub"
                className="grid h-9 w-9 place-items-center rounded-lg border border-white/15 text-ink-muted transition-colors hover:border-primary-glow/40 hover:text-primary-glow"
              >
                <Github size={16} />
              </a>
            </div>
          </div>

          <div>
            <h3 className="font-display text-sm font-semibold mb-4 text-ink-foreground">
              Quick Links
            </h3>
            <ul className="space-y-2.5 text-sm text-ink-muted">
              <li>
                <Link to="/" className="hover:text-primary-glow">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/services" className="hover:text-primary-glow">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/about" className="hover:text-primary-glow">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/careers" className="hover:text-primary-glow">
                  Careers
                </Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-primary-glow">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-display text-sm font-semibold mb-4 text-ink-foreground">
              Services
            </h3>
            <ul className="space-y-2.5 text-sm text-ink-muted">
              <li>
                <Link to="/services/qa" className="hover:text-primary-glow">
                  Quality Engineering
                </Link>
              </li>
              <li>
                <Link to="/services/ai-ml" className="hover:text-primary-glow">
                  AI Engineering
                </Link>
              </li>
              <li>
                <Link to="/services/salesforce" className="hover:text-primary-glow">
                  Salesforce and ERP Implementation
                </Link>
              </li>
              <li>
                <Link to="/services/custom-software" className="hover:text-primary-glow">
                  Custom Development
                </Link>
              </li>
              <li>
                <Link to="/services/cloud" className="hover:text-primary-glow">
                  Cloud Engineering
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-display text-sm font-semibold mb-4 text-ink-foreground">Contact</h3>
            <ul className="space-y-3 text-sm text-ink-muted">
              <li className="flex items-start gap-2.5">
                <MapPin size={16} className="mt-0.5 shrink-0 text-primary-glow" />
                <span>
                  6th Floor, MPR Arcade, Plot No. 35, Cyber Hills Colony, VIP Hills, Silicon Valley,
                  Madhapur, Hyderabad, Telangana 500081
                </span>
              </li>
              <li className="flex items-start gap-2.5">
                <MapPin size={16} className="mt-0.5 shrink-0 text-primary-glow" />
                <span>
                  D102, D Tower, Godrej Avenues, Singanayakanahalli, Yelahanka, Bangalore, Karnataka
                  560064
                </span>
              </li>
              <li className="flex items-start gap-2.5">
                <Mail size={16} className="mt-0.5 shrink-0 text-primary-glow" />{" "}
                info@stantivesoft.in
              </li>
              <li className="flex items-start gap-2.5">
                <Phone size={16} className="mt-0.5 shrink-0 text-primary-glow" /> +91 9088993699
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-3 border-t border-white/10 pt-6 text-xs text-ink-muted sm:flex-row">
          <p>© {new Date().getFullYear()} Stantive Soft Solutions. All rights reserved.</p>
          <p>Built with care in India, delivered worldwide.</p>
        </div>
      </div>
    </footer>
  );
}
